export const STORE_GROUPS_VIEW_PATH = "/storeGroups";

export const CREATE_STORE_GROUP_VIEW_PATH = "/storeGroups/create";

export const STORE_GROUP_DETAIL_VIEW_PATH = "/storeGroups/:storeGroupUuid";

export const EDIT_STORE_GROUP_VIEW_PATH: string =
  "/storeGroups/:storeGroupUuid/edit";
